module.exports = __webpack_public_path__ + "static/media/snake.dae08b3f.jpg";